module.exports = require("@feizheng/noop");